import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";

import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { changeCreLicensePurchases } from "redux/actions/purchases/purchasesAction";

export const PurchasesLicenseInput = () => {
  const dispatch = useDispatch();

  const { creLicenses, creLicenseSelected } = useSelector(
    (state) => state.purchases
  );

  const licenseOptions = useMemo(
    () =>
      creLicenses
        .filter((license) => license.creLicense)
        .map((license) => ({
          ...license,
          label: `${license.name} - ${license.creLicense}`,
          value: license.creLicense,
        })),
    [creLicenses]
  );

  const handleChangeLicense = (value) => {
    dispatch(changeCreLicensePurchases(value));
  };

  return (
    <Grid item xs={12} sm={4}>
      <AutocompleteComponent
        label="Licencias"
        size="small"
        keyOption="value"
        options={licenseOptions}
        value={creLicenseSelected || null}
        disabled={licenseOptions.length === 0}
        customAction={handleChangeLicense}
        noOptionsText="No se encuentra licencia"
      />
    </Grid>
  );
};
